module.exports = angular.module('cartographer.map.inspector', [])

_ = require 'underscore'

module.exports.factory 'crtMapInspectorState', $DI (crtLog) ->
  class crtMapInspectorState
    # "mode,flag,flag,..." { credentials: or(credentials, null) } -> crtMapInspectorState
    constructor: (mode, options = { credentials: null }) ->
      crtLog.debug('crtMapInspectorState.constructor', mode, options)
      @_selected           = null
      @_inspectorEnabled   = true
      @_optionsEnabled     = true
      @_photosEnabled      = !!options.credentials # we can only see photos if we can sign S3 URLs
      @_chartsEnabled      = true
      @_layerSelectEnabled = true
      tokens = (mode ? 'yes').toLowerCase().split(",")
      for token in tokens then switch token
        when 'data'          then @_selected           = 'data'
        when 'options'       then @_selected           = 'options'
        when 'photos'        then @_selected           = 'photos'
        when 'nodata'        then @_inspectorEnabled   = false
        when 'nooptions'     then @_optionsEnabled     = false
        when 'nophotos'      then @_photosEnabled      = false
        when 'nocharts'      then @_chartsEnabled      = false
        when 'nolayerselect' then @_layerSelectEnabled = false
        when 'no', 'false'
          @_selected         = null
          @_optionsEnabled   = false
          @_photosEnabled    = false
      if @optionsSelected() && !@optionsEnabled() then @_selected = 'data'
      if @photosSelected()  && !@photosEnabled()  then @_selected = 'data'
      @_showInspector = @_selected != null
      return

    inspectorEnabled     : => @_inspectorEnabled
    showInspector        : => @_showInspector

    # Show attributes when no feature is selected?
    alwaysShowAttributes : => @_layerSelectEnabled

    optionsEnabled       : => @_optionsEnabled
    photosEnabled        : => @_photosEnabled
    chartsEnabled        : => @_chartsEnabled
    layerSelectEnabled   : => @_layerSelectEnabled

    optionsSelected      : => @_selected == 'options'
    photosSelected       : => @_selected == 'photos'

    setShowInspector     : (show) => @_showInspector = show

    queryParameter       : =>
      if @_selected
        ans = @_selected
        unless @_inspectorEnabled   then ans += ",nodata"
        unless @_optionsEnabled     then ans += ",nooptions"
        unless @_photosEnabled      then ans += ",nophotos"
        unless @_chartsEnabled      then ans += ",nocharts"
        unless @_layerSelectEnabled then ans += ",nolayerselect"
        ans
      else
        'no'

  create = (mode, options = { enablePhotos: true }) ->
    new crtMapInspectorState(mode, options)

  return {
    create
  }

module.exports.directive 'crtMapInspector', $DI (crtLog, crtConfig) ->
  return {
    restrict: 'A'
    replace: true
    template: require './inspector.tpl.html'
    controllerAs: 'crtMapInspector'
    bindToController: true
    scope:
      inspectorState : '='  # crtMapInspectorState
      featureLayer   : '='  # crtFeatureLayer
      attributeLayer : '='  # crtAttributeLayer
      subdomain      : '='  # string
      from           : '='  # or(Date null)
      to             : '='  # or(Date null)
      crossws        : '='  # or(boolean null)
      urlParams      : '='  # object(string, string)
      buckets        : '='  # crtAttributeBuckets
      features       : '='  # arrayOf(feature)
      selection      : '='  # crtFeatureMapSelection
      widget         : '='  # or(boolean null)
      downloadLink   : '=?' # string -> string
    controller: $DI ($scope) ->
      crtMapInspector = this

      crtMapInspector.showOptions =
        crtMapInspector.inspectorState.optionsSelected()

      crtMapInspector.showPhotos =
        crtMapInspector.inspectorState.photosSelected()

      crtMapInspector.showGlPreview =
        crtConfig.preview.gl.enable &&
        !crtMapInspector.widget &&
        crtMapInspector.featureLayer.atlasMapId?

      # Visibility ------------------------------

      crtMapInspector.showDataInspector = ->
        !crtMapInspector.showOptions &&
        !crtMapInspector.showPhotos &&
        !crtMapInspector.attributeLayer?

      crtMapInspector.showAttributeInspector = ->
        !crtMapInspector.showOptions &&
        !crtMapInspector.showPhotos &&
        crtMapInspector.attributeLayer?

      crtMapInspector.showPhotoInspector = ->
        crtMapInspector.showPhotos

      crtMapInspector.showOptionsInspector = ->
        crtMapInspector.showOptions

      crtMapInspector.showColumn1 = ->
        !crtMapInspector.showOptions &&
        !crtMapInspector.showPhotos &&
        !crtMapInspector.attributeLayer?

      crtMapInspector.showColumn2 = ->
        !crtMapInspector.showOptions &&
        (crtMapInspector.attributeLayer? || crtMapInspector.showPhotos)

      crtMapInspector.showColumn3 = ->
        crtMapInspector.showOptions

      # Transitions -----------------------------

      crtMapInspector.onOptionsClick = ->
        crtMapInspector.showOptions = true
        return

      crtMapInspector.onPhotosClick = ->
        crtMapInspector.showPhotos = true
        return

      crtMapInspector.onAttributeClick = (attr) ->
        if crtMapInspector.inspectorState.layerSelectEnabled()
          crtMapInspector.showOptions = false
          crtMapInspector.showPhotos = false
          crtMapInspector.attributeLayer = attr
        return

      crtMapInspector.onBackClick = ->
        if crtMapInspector.showOptions
          crtMapInspector.showOptions = false
        else if crtMapInspector.showPhotos
          crtMapInspector.showPhotos = false
        else if crtMapInspector.inspectorState.layerSelectEnabled()
          crtMapInspector.attributeLayer = null
        return

      return
  }
